export function trackGTMEvent(
  eventName: string,
  eventParams: Record<string, any> = {},
) {
  if (typeof window !== 'undefined' && window.dataLayer) {
    console.log('trackEvent: Tracking event', eventName, eventParams);

    // Ensure dataLayer is initialized
    if (!Array.isArray(window.dataLayer)) {
      window.dataLayer = [];
    }

    window.dataLayer.push({
      event: eventName,
      ...eventParams,
    });
  } else {
    console.warn(
      'trackEvent: dataLayer is not available. Event will not be tracked.',
      eventName,
      eventParams,
    );
  }
}
